var getCartContents = function getCartContents(cartProducts) {
  try {
    if (!Array.isArray(cartProducts)) {
      console.log("cartContent error - must pass array");
    }

    var cartContentsArray = [];
    cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.forEach(function (element) {
      var product = element.Product || {};
      cartContentsArray.push(getCartContentsValueByProductType(product === null || product === void 0 ? void 0 : product.CatalogName));
    });
    return sortCartContentsStringAlphabetically(cartContentsArray);
  } catch (error) {
    console.log("CART CONTENTS ERROR - " + error);
    return "";
  }
};

var getCartContentsValueByProductType = function getCartContentsValueByProductType(cartContentType) {
  if (cartContentType === null || cartContentType === undefined || cartContentType === "") {
    return "";
  }

  switch (cartContentType.toLowerCase()) {
    case "retail":
      return "shop";

    case "cater":
      return "cater";

    case "eat":
      return "eat";

    case "cb_food_store":
      return "eat";

    case "cb_retail_store":
      return "shop";

    case "cb_food_catering":
      return "cater";

    default:
      return "";
  }
};

var getProductCatalogTypeForProduct = function getProductCatalogTypeForProduct(cartContentType) {
  var productCatalogType = getCartContentsValueByProductType(cartContentType);
  return productCatalogType;
};

var sortCartContentsStringAlphabetically = function sortCartContentsStringAlphabetically(cartContentsArray) {
  if (!Array.isArray(cartContentsArray)) {
    console.log("cartContentsArray error - must pass array");
  }

  var uniqueCartContents = cartContentsArray.filter(function (item, pos, self) {
    return self.indexOf(item) == pos;
  }); //Sort Alphabetically

  uniqueCartContents.sort(function (a, b) {
    var textA = a.toLowerCase();
    var textB = b.toLowerCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
  var result = uniqueCartContents.join("|").replace(/\s/g, "");
  return result;
};

var isShopProduct = function isShopProduct(cartContentType) {
  var productCatalogType = getProductCatalogTypeForProduct(cartContentType);
  return productCatalogType === "shop";
};

export { getCartContents, isShopProduct };